import { useEffect } from 'react';
import { Box, Button, Image, Text, useBreakpointProp } from '@bonanza-social/moonlight';
import { TypographyNames } from '@bonanza-social/moonlight/lib/common/Text/Text.types';
import { Modal } from '@bonanza-social/navigation';
import { AsyncStorage } from '@bonanza-social/toolkit/storage';
import { MARKETING_OPT_OUT_MODAL_SHOWN_STORAGE_KEY } from '../../../components/Registration/Registration.constants';

type MarketingOptOutModalProps = {
  onOptIn: () => void;
  onOptOut: () => void;
};

function MarketingOptOutModal({
  onOptIn,
  onOptOut,
}: MarketingOptOutModalProps) {
  useEffect(() => {
    AsyncStorage.setItem(MARKETING_OPT_OUT_MODAL_SHOWN_STORAGE_KEY, 'true');
  }, []);

  const titleTextVariant = useBreakpointProp<TypographyNames>({
    mobile: 'h4',
    tablet: 'h2',
    desktop: 'h2',
  });

  const descriptionTextVariant = useBreakpointProp<TypographyNames>({
    mobile: 'body-m',
    tablet: 'body-l',
    desktop: 'body-l',
  });

  return (
    <Box
      flex={1}
      variant="outline-gradient"
      padding="space-800"
      gap="space-500"
      gradient="borderAccent"
      borderWidth="border-width-025"
      borderRadius="radius-400"
    >
      <Image
        name="common.Megaphone"
        width={120}
        height={100}
        alignSelf="center"
      />
      <Text
        variant={titleTextVariant}
        locNS="registration"
        locKey="marketingOptOutModalTitle"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Text
        variant={descriptionTextVariant}
        locNS="registration"
        locKey="marketingOptOutModalDescription"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Box flexDirection="column" gap="space-400">
        <Button
          variant="primary"
          locNS="registration"
          locKey="marketingOptOutModalPositiveCTA"
          color="darkSurfacePrimary"
          size="large"
          onPress={() => {
            onOptIn();
            Modal.close();
          }}
        />
        <Button
          variant="secondary"
          locNS="registration"
          locKey="marketingOptOutModalNegativeCTA"
          color="darkSurfacePrimary"
          size="large"
          onPress={() => {
            onOptOut();
            Modal.close();
          }}
        />
      </Box>
    </Box>
  );
}

export default MarketingOptOutModal;
